/* =========================================================
   TOTAL FOOTY CO — RECENTLY VIEWED PRODUCTS
   Stores viewed product handles in localStorage and renders
   product cards on the recently-viewed section, excluding the
   product currently being viewed.
   ========================================================= */
(function () {
  "use strict";
  var STORAGE_KEY = "tfc_recently_viewed";
  var MAX_ITEMS = 8;

  function getStored() {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setStored(handles) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, MAX_ITEMS)));
    } catch (e) {
      /* localStorage unavailable — fail silently, section just won't populate */
    }
  }

  var root = document.querySelector("[data-recently-viewed]");
  var currentHandle = root ? root.getAttribute("data-current-handle") : null;

  if (currentHandle) {
    var stored = getStored().filter(function (h) { return h !== currentHandle; });
    stored.unshift(currentHandle);
    setStored(stored);
  }

  if (!root) return;

  var handles = getStored().filter(function (h) { return h !== currentHandle; }).slice(0, 4);
  if (!handles.length) {
    root.hidden = true;
    return;
  }

  Promise.all(
    handles.map(function (handle) {
      return fetch("/products/" + handle + "?view=card")
        .then(function (r) { return (r.ok ? r.text() : null); })
        .catch(function () { return null; });
    })
  ).then(function (htmlChunks) {
    var valid = htmlChunks.filter(Boolean);
    if (!valid.length) { root.hidden = true; return; }
    var grid = root.querySelector("[data-recently-viewed-grid]");
    if (grid) grid.innerHTML = valid.join("");
    root.hidden = false;
  });
})();
